import React, { Suspense } from 'react';

export const PublicTreatmentComponent = React.lazy(() => import('./PublicTreatment'));

export const PublicTreatment = () => (
  <Suspense fallback={null}>
    <PublicTreatmentComponent />
  </Suspense>
);
